export const userForm = {
  name: '',
  studentId: '',
  department: '',
  phoneNo: '',
  password: '',
};

export const developerStackList = [
  { id: 0, label: 'C', checked: false },
  { id: 1, label: 'Python', checked: false },
  { id: 2, label: 'Java', checked: false },
  { id: 3, label: 'HTML', checked: false },
  { id: 4, label: 'CSS', checked: false },
  { id: 5, label: 'JavaScript', checked: false },
  { id: 6, label: 'TypeScript', checked: false },
  { id: 7, label: 'React', checked: false },
  { id: 8, label: 'Next.js', checked: false },
  { id: 9, label: 'Vue', checked: false },
  { id: 10, label: 'Node', checked: false },
  { id: 11, label: 'Spring', checked: false },
  { id: 12, label: 'Django', checked: false },
  { id: 13, label: 'Flask', checked: false },
];

export const designerStackList = [
  { id: 0, label: '피그마', checked: false },
  { id: 1, label: '어도비 XD', checked: false },
  { id: 2, label: '일러스트레이터', checked: false },
  { id: 3, label: '제플린', checked: false },
  { id: 4, label: '포토샵', checked: false },
];

// export const time = [
//   { id: 0, label: '2월 22일 토요일 오전 (9AM~12PM)', checked: false },
//   { id: 1, label: '2월 22일 토요일 오후 (13AM~17PM)', checked: false },
//   { id: 2, label: '2월 22일 토요일 저녁 (19PM~22PM)', checked: false },

//   { id: 3, label: '2월 23일 일요일 오전 (9AM~12PM)', checked: false },
//   { id: 4, label: '2월 23일 일요일 오후 (13AM~17PM)', checked: false },
//   { id: 5, label: '2월 23일 일요일 저녁 (19PM~22PM)', checked: false },

//   { id: 6, label: '2월 24일 월요일 저녁 (19PM~22PM)', checked: false },

//   { id: 7, label: '모두 가능합니다!', checked: false },
// ];

/*
  { id: 0, label: '2월 28일 금요일 오전 (9AM~12PM)', checked: false },
  { id: 1, label: '2월 28일 금요일 오후 (13AM~17PM)', checked: false },
  { id: 2, label: '2월 28일 금요일 저녁 (19PM~22PM)', checked: false },

  { id: 3, label: '3월 1일 토요일 오전 (9AM~12PM)', checked: false },
  { id: 4, label: '3월 1일 토요일 오후 (13AM~17PM)', checked: false },
  { id: 5, label: '3월 1일 토요일 저녁 (19PM~22PM)', checked: false },

  { id: 6, label: '모두 가능합니다!', checked: false },
*/

export const time = [
  { id: 0, label: '2월 28일 토요일 오전 10AM~11AM', checked: false },
  { id: 1, label: '2월 28일 토요일 오전 11AM~12PM', checked: false },
  { id: 2, label: '2월 28일 토요일 오후 12PM~13PM', checked: false },

  { id: 3, label: '2월 28일 토요일 오후 13PM~14PM', checked: false },
  { id: 4, label: '2월 28일 토요일 오후 14PM~15PM', checked: false },
  { id: 5, label: '2월 28일 토요일 오후 15PM~16PM', checked: false },

  { id: 6, label: '2월 28일 토요일 오후 16PM~17PM', checked: false },
  { id: 7, label: '2월 28일 토요일 오후 17PM~18PM', checked: false },
  { id: 8, label: '2월 28일 토요일 오후 18PM~19PM', checked: false },

  { id: 9, label: '모두 가능합니다!', checked: false },
];

export const developerApplyForm = {
  motive: '',
  projectTopic: '',
  language: '',
  link: '',
  applicationField: 1,
  confidenceLang: 1,
  orientation: false,
  expProject: '',
  expSolve: '',
  seminarTopic: '',
  expStudy: '',
};

export const designerApplyForm = {
  motive: '',
  confidenceTool: 1,
  activityPlan: '',
  expSolve: '',
  orientation: false,
};
